<div class="memory-card">
  <!-- Card Header -->
  <div class="card-header">
    <div class="memory-number">
      <i class="fa-solid fa-lightbulb"></i>
      <span>#{{ index }}</span>
    </div>
    <span class="shared-badge" *ngIf="memory?.isShared === true && memory?.sharedFrom?.name"
      [title]="'Shared into ' + memory?.sharedFrom?.name">
      <i class="fa-solid fa-share-nodes"></i>
      {{ memory?.sharedFrom?.name }}
    </span>
    <div class="card-actions" *ngIf="showActions">
      <ng-content select="[card-actions]"></ng-content>
    </div>
  </div>

  <!-- Memory Content -->
  <div class="card-content">
    <p class="memory-text">{{ memory?.memory }}</p>
  </div>

  <!-- Keywords Section -->
  <div class="keywords-section" *ngIf="memory?.tokens && memory.tokens.length > 0">
    <div class="keywords-label">
      <i class="fa-solid fa-tags"></i>
      <span>Keywords</span>
    </div>
    <div class="keywords-list">
      <span class="keyword-chip" *ngFor="let token of memory?.tokens">
        <i class="fa-solid fa-hashtag"></i>
        {{ token }}
      </span>
    </div>
  </div>

  <!-- Tag Section (notesKey) -->
  <div class="tag-section" *ngIf="memory?.notesKey">
    <div class="tag-label">
      <i class="fa-solid fa-tag"></i>
      <span>Tag</span>
    </div>
    <span class="tag-badge">
      <i class="fa-solid fa-bookmark"></i>
      {{ memory.notesKey }}
    </span>
  </div>

  <!-- Card Footer -->
  <div class="card-footer">
    <div class="metadata-item" *ngIf="memory?.transactionNumber"
      [title]="'Transaction: ' + memory?.transactionNumber">
      <i class="fa-solid fa-fingerprint"></i>
      <span class="metadata-text">{{ memory?.transactionNumber | slice:0:12 }}...</span>
    </div>
    <div class="metadata-item" *ngIf="memory?.date" [title]="'Created: ' + memory?.date">
      <i class="fa-solid fa-clock"></i>
      <span class="metadata-text">{{ memory?.date }}</span>
    </div>
  </div>
</div>
